import React from "react";
import { Space, Select, Form } from "antd";
import { AndroidFilled, AppleOutlined } from "@ant-design/icons";
import { IntelligenceFormFieldsEnum } from "../../enum";
import { FormInstance, SelectProps } from "antd/lib";

export const PlatformInputField: React.FC<SelectProps & { form: FormInstance }> = ({ form, ...selectProps }) => {
    const productCodeWatch = Form.useWatch(IntelligenceFormFieldsEnum.PRODUCT_CODE, form);

    const options = React.useMemo(() => {
        return productCodeWatch
            ? [
                  { value: `${productCodeWatch}a`, label: "Android", icon: <AndroidFilled /> },
                  { value: `${productCodeWatch}i`, label: "IOS", icon: <AppleOutlined /> },
              ]
            : [];
    }, [productCodeWatch]);

    return (
        <Select
            className="min-w-[200px] mb-0 pr-2"
            mode="multiple"
            placeholder="Platform"
            options={options}
            optionRender={(option) => {
                return (
                    <Space>
                        {option.data.icon}
                        {option.label}
                    </Space>
                );
            }}
            {...selectProps}
        />
    );
};
